function scatterCan(symbol) {
	symbol = +symbol;

	if (!game.specials[symbol].reels) {
		return true;
	}

	if (game.specials[symbol].reels.indexOf(game.spindle.stop) === -1) {
		return false;
	}

	if ([ 1, 2 ].indexOf(game.spindle.stop) !== -1 && game.specials[symbol].reels.indexOf(0) !== -1) {
		if (game.last.matrix[0].indexOf(symbol) !== -1) {
			return true;
		}
	}

	if (game.specials[symbol].completesWin) {
		if (game.spindle.stop > 1) {
			return game.last.animate[game.spindle.stop - 1].indexOf(true) !== -1;
		}
	}

	if (game.specials[symbol].count === null) {
		return false;
	}

	var can = 0;

	for (var reel = game.spindle.stop; reel < game.spindle.reels.length; reel++) {
		if (game.specials[symbol].reels.indexOf(reel) !== -1) {
			can++;
		}
	}

	if (!game.specials[symbol].needs || game.specials[symbol].count + can >= game.specials[symbol].needs) {
		return true;
	}

	return false;
}

function spinClear() {
	if (!game.feature.active) {
		game.messaging.show('logo')
	}

	game.spindle.clear();
	game.spindle.stop = -3;
	game.spindle.ready = 0;

	game.panel.setWin(0, true);
	game.pays.clear();

	for (var reel in game.frame.reels) {
		for (var row in game.frame.reels[reel].symbols) {
			game.spindle.reels[reel].window.symbols[row].removeClass('hide');

			if (!game.last.sticky || !game.last.sticky[reel][row]) {
				game.frame.reels[reel].symbols[row].attr('class', 'symbol');
			}
		}
	}

	game.trigger('spin_clear');
}

function spinInit(recall) {
	var response = game.last;

	game.panel.hide();

	game.spindle.done = 0;
	game.spindle.stop = 0;

	if (game.turbo) {
		game.spindle.stop = -1;
	}

	var reel;
	var row;
	var pay;

	response.animate = [];

	for (reel in game.frame.reels) {
		response.animate[reel] = [];

		for (row in game.frame.reels[reel].symbols) {
			response.animate[reel][row] = false;
		}
	}

	if (response.lines && response.lines.win) {
		if (response.lines.pays && response.lines.pays.length) {
			for (pay in response.lines.pays) {
				pay = response.lines.pays[pay];

				var line = pay[0];

				for (reel = 0; reel < pay[1]; reel++) {
					row = game.pays.lines[line][reel];

					response.animate[reel][row] = true;
				}
			}
		}
	}

	if (response.ways && response.ways.win) {
		if (response.ways.pays && response.ways.pays.length) {
			for (pay in response.ways.pays) {
				pay = response.ways.pays[pay];

				var symbol = pay[0];

				for (reel = 0; reel < pay[2]; reel++) {
					for (row = 0; row < response.matrix[reel].length; row++) {
						if (response.matrix[reel][row] === symbol || response.matrix[reel][row] === game.pays.wild) {
							response.animate[reel][row] = true;
						}
					}
				}
			}
		}
	}

	game.trigger('spin_init');

	game.trigger('round_init', {
		recall: recall,
		bet: game.last._cost,
		win: game.last.win,
	});
}

function spinReady(recall) {
	if (game.spindle.stop === -3) {
		game.spindle.stop = -2;
		return;
	}

	var response = game.last;

	for (var reel in response.matrix) {
		for (var row in response.matrix[reel]) {
			game.spindle.reels[reel].window.symbols[row].attr('class', 'symbol symbol-' + response.matrix[reel][row]);
		}
	}

	for (var s in game.specials) {
		game.specials[s].count = 0;
	}

	if (!recall) {
		game.trigger('spin_ready');
	}

	spinInit();
}

function spinDone(recall) {
	var response = game.last;

	game.pays.clear();

	var pay;
	var reel;
	var row;
	var symbol;
	var source;
	var target;

	if (response.scatters && response.scatters.pays && response.scatters.pays.length) {
		for (pay in response.scatters.pays) {
			pay = response.scatters.pays[pay];
			symbol = pay[0];
			var spots = pay[3] = [];

			var condition = game.pays.scatters.sequential ? (game.specials[symbol].reels ? (game.specials[symbol].reels[pay[1] - 1] + 1) : pay[1]) : true;

			for (reel in game.last.matrix) {
				for (row in game.last.matrix[reel]) {
					var data = {
						reel: reel,
						row: row,
						symbol: symbol,
						matrix: game.last.matrix[reel][row],
						match: (condition === true || reel < condition) && game.last.matrix[reel][row] === symbol,
					};

					game.pays.trigger('identify-scatter', data);

					if (!data.match) {
						continue;
					}

					spots.push([ reel, row ]);

					game.last.animate[reel][row] = true;

					source = game.spindle.reels[reel].window.symbols[row];
					target = game.frame.reels[reel].symbols[row];

					target.attr('class', source.attr('class')).addClass('win');
					source.addClass('hide');
				}
			}

			game.pays.add('scatter', pay);
		}
	}

	game.trigger('spin_pre_done');
	game.sounds.fade([ 'spin' ], 1, 0, 1);
	game.sounds.fade([ game.feature.active, 'spin' ], 1, 0, 1);

	if (!recall && response.bonuses && response.bonuses.length && !game.last.delayBonus) {
		game.messaging.hide('logo');
		game.pays.show();
		game.feature.begin(response.bonuses.pop());

		return;
	}

	else if (game.last.delayBonus) {
		game.last.delayBonus = false;

		return;
	}

	if (response.lines && response.lines.win) {
		if (response.lines.pays && response.lines.pays.length) {
			response.lines.pays.sort(function(a, b) {
				if (a[1] === b[1] && a[2] === b[2]) {
					return a[0] > b[0] ? 1 : -1;
				}

				else if (a[2] === b[2]) {
					return a[1] < b[1] ? 1 : -1;
				}

				else {
					return a[2] < b[2] ? 1 : -1;
				}
			});

			for (pay in response.lines.pays) {
				pay = response.lines.pays[pay];
				if (typeof pay[4] !== 'number') {
					pay[4] = pay[3];
				}

				pay[3] = [];

				for (reel = 0; reel < pay[1]; reel++) {
					row = game.pays.lines[pay[0]][reel];

					pay[3].push([ reel, row ]);
				}
			}

			for (pay in response.lines.pays) {
				// console.log(response.lines.pays[pay]);
				game.pays.add('line', response.lines.pays[pay]);
			}
		}
	}

	if (response.ways && response.ways.win) {
		if (response.ways.pays && response.ways.pays.length) {

			for (pay in response.ways.pays) {
				pay = response.ways.pays[pay];

				pay[3] = [];

				for (reel = 0; reel < pay[2]; reel++) {
					for (row = 0; row < game.last.matrix[reel].length; row++) {
						if (game.last.matrix[reel][row] === pay[0] || game.last.matrix[reel][row] === game.pays.wild || (game.last.sticky && game.last.sticky[reel][row])) {
							pay[3].push([ reel, row ]);
						}
					}
				}
			}

			for (pay in response.ways.pays) {
				pay = response.ways.pays[pay];
			}

			for (pay in response.ways.pays) {
				game.pays.add('way', response.ways.pays[pay]);
			}
		}
	}

	for (reel in game.frame.reels) {
		for (row in game.frame.reels[reel].symbols) {
			if (response.animate[reel][row] || (response.sticky && response.sticky[reel][row])) {
				source = game.spindle.reels[reel].window.symbols[row];
				target = game.frame.reels[reel].symbols[row];

				if (response.sticky && response.sticky[reel][row]) {
					target.attr('class', 'symbol symbol-0');
				}

				else {
					target.attr('class', source.attr('class'));
				}

				source.addClass('hide');
			}
		}
	}

	if (!recall) {

		if (!game.feature.active && game.panel.state !== 'lock') {
			game.panel.enable();
		}
	}

	game.panel.show();

	if ((!game.last._cost && game.old && !game.old._cost)) {

		var bet;

		if (game.config.lines) {
			bet = game.panel.getBet();

			game.last._cost = bet.lines * bet.coins;
		}

		else {
			bet = game.panel.getBet();

			game.last._cost = game.config.ways.cost * bet.coins;
		}
	}

	if (response.win) {
		game.messaging.hide();

		if (!game.last.delayWin) {
			game.pays.show();
		}

		if (recall) {
			game.panel.setWin(response.win, true);
			game.trigger('round_complete');
		}

		else {
			if (game.feature.active) {
				game.sounds.fade([ game.feature.active, 'background' ], 1, 0.15, 0.5);
			}

			else {
				game.sounds.fade([ 'background' ], 1, 0.15, 0.5);
			}

			if (!game.last.delayWin) {
				game.panel.setWin(response.win);
			}
		}
	}

	else if (game.pays.list && game.pays.list.length) {
		game.messaging.hide();

		if (!game.last.delayWin) {
			game.pays.show();
			setTimeout(function() {
				game.trigger('round_complete');
			}, recall ? 0 : 2000);
		}
	}

	else if(!game.last.doubleRollup) {
		game.trigger('round_complete');
	}

	game.trigger('spin_done');
	game.trigger('round_done', { recall: recall });
}

window.scatterCan = scatterCan;
window.spinClear = spinClear;
window.spinInit = spinInit;
window.spinReady = spinReady;
window.spinDone = spinDone;



/** WEBPACK FOOTER **
 ** ./../../public-src/common/js/utils.js
 **/